import React, { useEffect, useState, useMemo } from "react";
import { Helmet } from "react-helmet";
import { apiUrl } from '../constants'
import axios from 'axios'
import CardPhoto from '../components/card/CardPhotoToUseLocation';
import { Box, Grid, Container, Tab, Tabs, Toolbar, Typography, useTheme } from "@mui/material";
import { tokens } from "../theme";
import chickenKoratImg from "../assets/img/chickenKorat.jpg"
import { useSelector } from 'react-redux';
import useCheckToken from '../hooks/useCheckToken';
import useExchangeToken from "../hooks/useExchangeToken";
import { useParams } from 'react-router-dom';
import Vietnam from '../assets/img/vietnam.jpg';


const CardPhotoMemo = React.memo(CardPhoto);

const LineDetail = () => {
  const { bu, plant, factory, line } = useParams();
  const exchangeToken = useExchangeToken();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [module, setModule] = useState([]);
  const [isTokenExchanged, setIsTokenExchanged] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useCheckToken();

  const ac_token = useSelector(state => state.auth.access_token);
  const group = useSelector((state) => state.auth.group);

  useEffect(() => {
    const fetchInitialTokenAndData = async () => {
      try {
        const token = await exchangeToken(); 
        if (token) {
          setIsTokenExchanged(true); 
        }
      } catch (err) {
        console.error("Error exchanging token:", err);
        setError("Failed to exchange token");
      }
    };

    fetchInitialTokenAndData();
  }, [exchangeToken]);


  useEffect(() => {
    const fetchMyAPI = async () => {
      if (!ac_token) return; 
      setLoading(true);
      try {
        const response = await axios.get(`${apiUrl.MASTER_PLANT}${bu}/${plant}/${factory}/${line}`, {
          headers: {
            Authorization: `Bearer ${ac_token}`,
          },
        });

        if (response.status === 200) {
          setModule(response.data.MODULE || [])
        }
      } catch (err) {
        setError(err.message);
        console.error("Error fetching module data:", err);
      } finally {
        setLoading(false);
      }
    };

    if (isTokenExchanged && ac_token) {
    fetchMyAPI(); 
    }
  }, [isTokenExchanged, ac_token]);

  module.sort((a, b) => {
    if (a.length !== b.length) {
      return a.length - b.length;
    }
    return a.localeCompare(b);
  });

  // const filterBUData = (group, module_from_api) => {
  //   if (group === "All") {
  //     return module_from_api; // แสดงผลทั้งหมดถ้า bu_store เป็น 'all'
  //   } else if (group === "None") {
  //     return module_from_api;
  //   } else if (group === "-") {
  //     return module_from_api;
  //   }
  //   return module_from_api.filter((item) => item === group); // กรองเฉพาะ BU ที่ตรงกับ bu_store
  // };

  const filterBUData = (group, module_from_api = []) => {
    const value = (group ?? "").trim().toLowerCase();

    if (
      value === "all" ||
      value === "none" ||
      value === "-"
    ) {
      return module_from_api;
    }

    return module_from_api.filter(
      (item) => String(item).toLowerCase() === value
    );
  };

  const imageMap = {
    "4117": chickenKoratImg,
    "B425": Vietnam,
  };
  
  const getImageByPlant = (name) => imageMap[name] ?? chickenKoratImg;

  const moduleData = useMemo(() => {
    const filteredBu = filterBUData(group, module);
    return filteredBu.length === 0
      ? []
      : filteredBu.map((name, index) => ({
          key: index,
          name,
          fileLocation: getImageByPlant(plant),
        }));
  }, [module, group, plant]);
  





  return (
    <Box style={{ width: "100%", height: "90vh" }}>
      <Helmet>
        <title>Line | MES</title>
      </Helmet>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <Box
            m='1%'
            display="grid"
            gridTemplateColumns="repeat(12, 1fr)"
            gridAutoRows={moduleData.length > 6 ? "50%" : "100%"}
            columnGap="1%"
            rowGap="6%"
          >
            {/* ESTIMATED */}
            {moduleData.map((item) => (
              <Box
                key={item.key || item.id}
                gridColumn="span 2"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <CardPhotoMemo name={item.name} fileLocation={item.fileLocation || chickenKoratImg} />
              </Box>
            ))
            }
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}

export default LineDetail
